/**
 * Utility functions for Service Provider Profile Preview feature (Feature 022)
 *
 * Provides visibility checks and data transformations for displaying
 * service provider profiles in their dashboard.
 */

/**
 * Determines if a service provider should see their profile preview
 *
 * Profile preview is shown for all account statuses EXCEPT SUSPENDED.
 * This allows SPs to preview their profile in all states:
 * - ACTIVE (any vetting status - profile visibility controlled by backend)
 * - PENDING_VERIFICATION (profile is hidden from others, but SP can preview)
 * - INACTIVE (profile is hidden from others, but SP can preview)
 * - SUSPENDED (profile preview is NOT shown)
 *
 * Vetting status does not affect preview visibility - only account status.
 *
 * @param accountStatus - The account status from user object
 * @param _vettingStatus - The vetting status from provider profile (not used for visibility check)
 * @returns true if profile preview should be shown
 */
export function shouldShowProfilePreview(
  accountStatus: string | undefined | null,
  _vettingStatus?: string | null,
): boolean {
  return accountStatus !== 'SUSPENDED' && accountStatus !== undefined && accountStatus !== null;
}
